import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetCurrenciesResponse,
  SetCurrenciesOptions,
  getCurrencies as universalGetCurrencies,
  setCurrencies as universalSetCurrencies,
} from './settings-v1-site-currency-site-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/currency-converter' };

export function setCurrencies(httpClient: HttpClient): SetCurrenciesSignature {
  return (options?: SetCurrenciesOptions) =>
    universalSetCurrencies(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SetCurrenciesSignature {
  /**
   * Sets the list of currencies that can be displayed on the site.
   *
   * When you set currencies for a site, visitors can view prices in any of these currencies.
   * Prices are automatically converted using up-to-date exchange rates.
   * The supplied list completely replaces the previous currency list.
   *
   * To disable currency conversion entirely, pass an empty array.
   */
  (options?: SetCurrenciesOptions): Promise<void>;
}

export function getCurrencies(httpClient: HttpClient): GetCurrenciesSignature {
  return () =>
    universalGetCurrencies(
      // @ts-ignore
      { httpClient }
    );
}

interface GetCurrenciesSignature {
  /**
   * Retrieves the list of currencies that can be displayed on the site.
   *
   * Returns all currencies that are currently enabled for the site.
   * Visitors can view prices in any of these currencies.
   */
  (): Promise<
    NonNullablePaths<
      GetCurrenciesResponse,
      `currencies` | `currencies.${number}.code`,
      4
    >
  >;
}

export {
  GetCheckoutCurrenciesRequest,
  GetCheckoutCurrenciesResponse,
  GetCurrenciesRequest,
  GetCurrenciesResponse,
  SetCheckoutCurrenciesRequest,
  SetCheckoutCurrenciesResponse,
  SetCurrenciesOptions,
  SetCurrenciesRequest,
  SetCurrenciesResponse,
  SiteCurrency,
} from './settings-v1-site-currency-site-settings.universal.js';
